// extracted by mini-css-extract-plugin
export default {"buttonContainer":"cookie-settings__buttonContainer___3Ieil","toBeReplaced":"cookie-settings__toBeReplaced___3iF_Q"};